import React, { useEffect, useMemo, useState } from "react";
// À l'essai (11/10/2026) : les questions de septembre repassées dans les QCM de suivi, à côté de la vue de septembre
import DepuisSeptembre from "../components/VueEvalNat/BilanEval/DepuisSeptembre";
import InterrupteurVue from "../components/VueEvalNat/BilanEval/InterrupteurVue";
import { normalizeMatiere } from "../utils/matiere";

import { useParams, useNavigate } from "react-router-dom";
import { useDeleteEvalNat } from "../hooks/delete_api_hook/useDeleteEvalNat";
import ResultatEvalNat from "../components/VueEvalNat/EvalNat/ResultatEvalNat";
import { useClasseContext } from "../context/ClasseContext";
import { useUser } from "../context/UserContext";
import { Trash2, ClipboardList, FileText, ChevronRight } from "lucide-react";
import PilotageHeader from "../components/general/PilotageHeader";
import useConfirm from "../hooks/ui/useConfirm";
import { importNationalesOuvert, MENTION_IMPORT_NATIONALES_A_VENIR } from '../utils/ouvertureImportNationales';

const OPTIONS_VUE_NATIONALE = [
  { cle: 'septembre', libelle: 'Septembre' },
  { cle: 'depuis', libelle: 'Depuis septembre', essai: true },
];

function EvalNational({EvalsNat, selectedMatiere}) {
    const {idclasse} = useParams();
    const navigate = useNavigate();
    const { deleteEvaluationNat } = useDeleteEvalNat();

    const [EvalNat, setEvalNat] = useState([]);
    // Le refus du serveur, dit tel quel (ex. 403 : ni chef ni délégué de l'établissement).
    const [erreurSuppression, setErreurSuppression] = useState(null);
    // Ce que le serveur a effacé, dit sur la page de la classe concernée seulement : { classe, texte }.
    const [suppressionFaite, setSuppressionFaite] = useState(null);


   const {classeNom} = useClasseContext();
   const { etablissementData, user } = useUser();
   const { confirm, ConfirmDialog } = useConfirm();
   // L'import EvalNat ne se fait plus par classe : porte unique au niveau
   // établissement, tenue par le chef et le professeur DÉLÉGUÉ (vue Résultats nationaux)
   const estDelegue = !!etablissementData?.professeurs?.find(p => p.id === user?.id)?.delegue_affectation;
   // Le délégué importe selon le drapeau (ouvertureImportNationales), le chef toujours.
   const importOuvert = importNationalesOuvert(user, estDelegue);
   // Un professeur qui n'est pas délégué consulte seulement : supprimer des résultats
   // importés revient à ceux qui importent (décision prof 09/10/2026).
   const peutGererImport = user?.role === 'chef' || estDelegue;

   useEffect( ()=> {

        if(EvalsNat){
            // Une classe sans aucune copie reçoit quand même la campagne de son niveau, vide (plan du 30/10/2026) :
            // la page dit qu'il n'y a pas de résultat national au lieu d'afficher une vue vide.
            setEvalNat(EvalsNat.filter((e) => e.titre === "Evaluation Nationale" && e.classe === parseInt(idclasse, 10)
                && (e.eleves_reponses || []).length > 0));
        }
   },
   [EvalsNat,idclasse])

   // À l'essai : « Septembre » (la vue actuelle, par défaut) ou « Depuis septembre » (tous les QCM de suivi)
   const [vue, setVue] = useState('septembre');
   const matiere = normalizeMatiere(selectedMatiere || user?.matiere);
   const septembre = useMemo(
     () => EvalNat.find((e) => !matiere || !e.matiere || normalizeMatiere(e.matiere) === matiere) || EvalNat[0] || null,
     [EvalNat, matiere]
   );
   const bilans = useMemo(() => (EvalsNat || []).filter((e) => e.titre !== "Evaluation Nationale"
     && e.classe === parseInt(idclasse, 10)
     && (!septembre?.matiere || !e.matiere || normalizeMatiere(e.matiere) === normalizeMatiere(septembre.matiere))
     && (e.eleves_reponses || []).some((r) => r.reponses)), [EvalsNat, idclasse, septembre]);


    

    // Supprime la matière affichée (celle de « septembre ») pour cette classe seulement : le serveur n'efface que
    // les copies de ses élèves, la campagne du niveau, les autres classes et les bilans restent.
    const handleDelete =  async () => {
        if (!septembre) return;
        const matiereCible = normalizeMatiere(septembre.matiere);
        const confirmed = await confirm({
          title: `Supprimer les résultats nationaux${matiereCible ? ` de ${matiereCible}` : ''} des élèves de la ${classeNom} ?`,
          message: "Les autres classes et les bilans ne bougent pas.",
          confirmLabel: "Supprimer",
          variant: "danger",
        });
        if (confirmed){
        // Les résultats ne disparaissent de l'écran que si le serveur les a vraiment supprimés.
        const resultat = await deleteEvaluationNat(septembre.id, septembre.classe);
        if (resultat?.success) {
          const n = resultat.data?.copies_supprimees;
          setErreurSuppression(null);
          setSuppressionFaite(typeof n === 'number'
            ? { classe: idclasse, texte: `${n} résultat${n > 1 ? 's' : ''} supprimé${n > 1 ? 's' : ''}.` }
            : null);
          setEvalNat([]);
        } else {
          const message = resultat?.error?.response?.data?.error;
          setErreurSuppression(typeof message === 'string' ? message : "La suppression n'a pas abouti. Réessayez.");
        }
         }
      }
  


return(

       EvalNat.length ===0  ? (
        /* Plus d'import PAR CLASSE (l'ancien wizard 2 étapes est retiré) :
           l'import des résultats nationaux se fait au niveau ÉTABLISSEMENT,
           par le chef ou le professeur délégué ; chaque prof retrouve ensuite
           les résultats dans ses classes automatiquement. */
        <div className="w-full min-h-full flex items-start justify-center p-2 sm:p-4">
          <div className="bg-white border-2 border-[#D5E6F3] rounded-2xl shadow-sm w-full max-w-2xl mt-6 sm:mt-10 p-6 sm:p-10 text-center">
            {suppressionFaite?.classe === idclasse ? (
              <p role="status" className="mb-4 px-3 py-2 rounded-lg bg-emerald-50 border border-emerald-200 text-sm font-semibold text-emerald-700">
                {suppressionFaite.texte}
              </p>
            ) : null}
            <div className="w-16 h-16 sm:w-20 sm:h-20 bg-[#EAF4FB] border border-[#D5E6F3] rounded-full flex items-center justify-center mx-auto mb-4">
              <FileText className="w-8 h-8 sm:w-10 sm:h-10 text-cyan-600" />
            </div>
            <h2 className="text-lg sm:text-xl font-extrabold text-slate-800 mb-2">
              Aucun résultat national pour la classe de {classeNom}
            </h2>
            <p className="text-sm sm:text-base text-slate-500 font-semibold max-w-lg mx-auto mb-5">
              L'import des évaluations nationales se fait pour tout l'établissement,
              par le <strong className="text-slate-700">chef d'établissement</strong> ou
              le <strong className="text-slate-700">professeur délégué</strong>.
              Une fois l'import réalisé, chaque professeur retrouve automatiquement
              les résultats dans ses classes.
            </p>
            {estDelegue && !importOuvert ? (
              <span
                className="inline-flex items-center gap-2 px-5 py-2.5 bg-gray-50 border border-gray-200 text-gray-400 rounded-xl font-bold text-sm"
                title="L'import des résultats nationaux par le professeur délégué n'est pas encore ouvert."
              >
                Importer les résultats de l'établissement · {MENTION_IMPORT_NATIONALES_A_VENIR}
              </span>
            ) : estDelegue ? (
              <button
                onClick={() => navigate('/home/eval-nat-niveau/')}
                className="inline-flex items-center gap-2 px-5 py-2.5 bg-blue-600 hover:bg-blue-700 text-white rounded-xl font-bold text-sm transition"
              >
                Importer les résultats de l'établissement
                <ChevronRight className="w-4 h-4" />
              </button>
            ) : (
              <p className="text-xs sm:text-sm text-slate-400 font-semibold">
                L'import est réalisé par le chef d'établissement ou le professeur délégué.
              </p>
            )}
          </div>
        </div>
       ) :
       <div className=" px-4 w-full pt-3">
        {/* En-tête standard Pilotage */}
        <PilotageHeader
          icone={ClipboardList}
          titre="Évaluations nationales"
          sousTitre={"Classe de " + classeNom}
          badgeNiveau={classeNom?.charAt(0)}
          action={peutGererImport ? (
            <button
              className="flex items-center gap-2 px-3.5 py-2 rounded-lg text-sm font-semibold text-red-600 border border-red-200 hover:bg-red-50 transition-colors duration-200"
              title="Supprimer"
              onClick={handleDelete}
            >
              <Trash2 size={16} />
              Supprimer
            </button>
          ) : null}
        />
        {erreurSuppression ? (
          <p role="alert" className="mt-2 px-3 py-2 rounded-lg bg-red-50 border border-red-200 text-sm font-semibold text-red-700">
            {erreurSuppression}
          </p>
        ) : null}

        <div className="mt-3 flex flex-wrap items-center gap-3">
          <InterrupteurVue etiquette="Affichage des résultats" options={OPTIONS_VUE_NATIONALE} valeur={vue} onChange={setVue} />
          {vue === 'depuis' ? <span className="text-xs text-slate-500">Les questions de septembre repassées depuis : qui les a acquises, qui doit les revoir.</span> : null}
        </div>

        <div className={vue === 'septembre' ? ' mb-52 w-full rounded-3xl bg-white' : 'hidden'}>
          <ResultatEvalNat EvalsNat={EvalsNat} selectedMatiere={selectedMatiere} />
        </div>
        {vue === 'depuis' ? (
          <div className="mt-4 mb-52 w-full">
            <DepuisSeptembre evalNat={septembre} bilans={bilans} />
          </div>
        ) : null}
        {ConfirmDialog}
       </div>
      
)
}

export default EvalNational;
